package com.essntl.features.country.ui.allcountries

import com.essntl.features.country.domain.model.CountryModel

sealed interface AllCountriesNavigation {
    data object AddCountry : AllCountriesNavigation
    data class EditCountry(val country: CountryModel) : AllCountriesNavigation
}